// Estilos compartilhados (I.A Recursos Humanos: claro corporativo, faixa verde-agua).
// Só aparência: cada página usa isto dentro do próprio makeStyles.

import { ondasMar } from "./estiloNavy";

const escuroDe = (theme) => theme.palette.type === "dark";

// Banner verde de topo de página, com planeta e órbita decorativos.
// Todo texto dentro dele fica branco; botões "contained" viram brancos.
export const bannerAstro = (theme) => {
  const escuro = escuroDe(theme);
  return {
    position: "relative",
    overflow: "hidden",
    padding: "22px 26px",
    borderRadius: 18,
    color: "#ffffff",
    background: "linear-gradient(120deg, #0b5e58 0%, #0d7a72 55%, #0f8f84 100%)",
    border: "none",
    boxShadow: escuro ? "0 6px 18px rgba(0,0,0,.35)" : "0 6px 18px rgba(13,94,88,.16)",
    animation: "iaSubir .4s ease backwards",
    // ondas do mar no pe da faixa
    ...ondasMar(),
    "& > *": { position: "relative", zIndex: 1 },
    "& .MuiTypography-root, & h1, & h2, & h3, & h4, & h5, & h6": { color: "#ffffff" },
    "& .MuiTypography-colorTextSecondary, & p": {
      color: "rgba(255,255,255,.85) !important",
    },
    "& .MuiSvgIcon-root": { color: "#ffffff" },
    "& .MuiButton-root .MuiSvgIcon-root": { color: "inherit" },
    "& .MuiButton-containedPrimary": {
      background: "#ffffff",
      color: "#0D9488",
      boxShadow: "0 6px 16px rgba(0,0,0,.15)",
      "& .MuiSvgIcon-root": { color: "#0D9488" },
      "&:hover": { background: "#f0fdfa" },
    },
    "& .MuiButton-outlined, & .MuiButton-text": {
      color: "#ffffff",
      borderColor: "rgba(255,255,255,.5)",
      "&:hover": { backgroundColor: "rgba(255,255,255,.12)" },
    },
  };
};

// Painel (caixa branca / verde-escura) com borda suave.
export const painelAstro = (theme) => {
  const escuro = escuroDe(theme);
  return {
    backgroundColor: theme.palette.background.paper,
    backgroundImage: escuro ? "linear-gradient(180deg, rgba(255,255,255,0.025), rgba(255,255,255,0))" : "none",
    border: escuro ? "1px solid rgba(148,163,184,.14)" : "1px solid #dcebe9",
    borderRadius: 16,
    boxShadow: escuro ? "0 8px 24px rgba(0,0,0,.3)" : "0 4px 14px rgba(10,38,36,.06)",
  };
};

// Cartão com linha colorida no topo, brilho no canto e hover que sobe.
export const cartaoAstro = (theme, cor = "#14b8a6") => {
  const escuro = escuroDe(theme);
  return {
    ...painelAstro(theme),
    position: "relative",
    overflow: "hidden",
    transition: "transform .25s ease, box-shadow .25s ease, border-color .25s ease",
    animation: "iaSubir .4s ease backwards",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      background: `linear-gradient(90deg, ${cor}, #2dd4bf)`,
    },
    "&:hover": {
      transform: "translateY(-2px)",
      borderColor: escuro ? "rgba(45,212,191,.35)" : "#b9e6e0",
      boxShadow: escuro
        ? "0 16px 36px rgba(0,0,0,.5), 0 0 22px rgba(20,184,166,.12)"
        : "0 14px 30px rgba(10,38,36,.12)",
    },
  };
};

// Texto escuro em etiqueta clara (ex.: salmão, amarelo) e branco nas escuras.
export const corDoTextoDaEtiqueta = (hex) => {
  const h = String(hex || "").replace("#", "");
  if (!/^[0-9a-f]{6}$/i.test(h)) return "#ffffff";
  const n = parseInt(h, 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  const luz = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luz > 0.68 ? "#1f293b" : "#ffffff";
};

// Título de seção com barrinha verde à esquerda.
export const tituloSecaoAstro = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: 10,
  fontSize: "0.74rem",
  fontWeight: 800,
  letterSpacing: "0.1em",
  textTransform: "uppercase",
  color: escuroDe(theme) ? "#cbd5e1" : "#1f3a2b",
  "&::before": {
    content: '""',
    width: 4,
    height: 16,
    borderRadius: 2,
    background: "linear-gradient(180deg, #14b8a6, #0d9488)",
  },
});
